import {EditorState} from "@codemirror/state";
import {drawSelection, EditorView, highlightSpecialChars, keymap, lineNumbers, ViewUpdate,} from "@codemirror/view";

import {defaultHighlightStyle, syntaxHighlighting} from "@codemirror/language";
import {defaultKeymap, history, historyKeymap} from "@codemirror/commands";
import {autocompletion, completionKeymap} from "@codemirror/autocomplete";
import {Injectable} from "@angular/core";
import {css} from "@codemirror/lang-css";

@Injectable({
    providedIn: "root",
})
export class CodemirrorService {

    baseTheme = EditorView.baseTheme({
        ".cm-gutterElement": {
            height: "19px!important"
        },
        ".cm-gutterElement:first-child": {
            height: "0px!important"
        },
        "&": {height: "100%"},
        ".cm-line":{
            height: "19px!important"
        },
        ".cm-underline": { textDecoration: "underline 3px red" }
    });

    getCssCmEditor(element: Element, doc?: string, onUpdate?: (update: ViewUpdate) => void): EditorView {
        const extensions = [
            autocompletion(),
            lineNumbers(),
            history(),
            drawSelection(),
            EditorState.allowMultipleSelections.of(true),
            syntaxHighlighting(defaultHighlightStyle, {fallback: true}),
            css(),
            this.baseTheme,
            keymap.of([
                ...defaultKeymap,
                ...historyKeymap,
                ...completionKeymap
            ])
        ];

        if (onUpdate)
            extensions.push(EditorView.updateListener.of(onUpdate));

        return new EditorView({
            state: EditorState.create({
                doc: doc,
                extensions: extensions
            }),
            parent: element
        });
    }

}